var render, staticRenderFns
import script from "./FormCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./FormCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormCheckboxGroup.vue?vue&type=style&index=0&id=1cca4f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cca4f5a",
  null
  
)

export default component.exports